import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Button, Dialog } from 'day8-ui';
import { cancelPlan } from '../../actions/planner';
import history from '../../history';

class CancelModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      reason: 'none',
      loading: false
    };
    this.updateChoice = this.updateChoice.bind(this);
    this.deletePlan = this.deletePlan.bind(this);
  }

  updateChoice(e) {
    this.setState({
      reason: e.target.value
    });
  }

  async  deletePlan() {
    const { reason } = this.state;
    const { planCode, returnTo } = this.props;

    this.setState({ loading: true });
    try {
      await this.props.cancelPlan(planCode, reason);
      this.props.onCloseModal();
      history.push(returnTo || '/plan');
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <Dialog
        open={this.props.modalIsOpen}
        onOpenChange={this.props.onCloseModal}
        scrollable
        title={<h2 className='dui-text-xl dui-mb-4'>Cancel plan?</h2>}
        showFooter
        footerComponent={(
          <div className='dui-flex dui-gap-4'>
            <div>
              <Button buttonType="SECONDARY" disabled={this.state.loading} onClick={this.props.onCloseModal}>Cancel</Button>
            </div>
            <div>
              <Button className={`dui-w-full`} disabled={this.state.loading} onClick={this.deletePlan}>{this.state.loading ? 'Deleting...' : 'Delete'}</Button>
            </div>
          </div>
        )}
      >
        <p>Please let us know why you&#39;re deleting this plan</p>
        <div className="dui-flex dui-flex-col dui-gap-2 dui-mt-4">
          <div className="">
            <label htmlFor="booked" className="radio-label">
              <input
                type="radio"
                name="reason"
                id="booked"
                value="booked"
                onChange={this.updateChoice}
                className="dui-mr-4"
              />
              I have another booking with Yacht Week
            </label>
          </div>
          <div className="">
            <label htmlFor="date" className="radio-label">
              <input
                type="radio"
                name="reason"
                id="date"
                value="date"
                onChange={this.updateChoice}
                className="dui-mr-4"
              />
              I can&#39;t find a date that works for everyone
            </label>
          </div>
          <div className="">
            <label htmlFor="new-plan" className="radio-label">
              <input
                type="radio"
                name="reason"
                id="new-plan"
                value="new-plan"
                onChange={this.updateChoice}
                className="dui-mr-4"
              />
              I want to start a different plan
            </label>
          </div>
          <div className="">
            <label htmlFor="yacht" className="radio-label">
              <input
                type="radio"
                name="reason"
                id="yacht"
                value="yacht"
                onChange={this.updateChoice}
                className="dui-mr-4"
              />
              I can&#39;t find a yacht I want to sail with
            </label>
          </div>
          <div className="">
            <label htmlFor="price" className="radio-label">
              <input
                type="radio"
                name="reason"
                id="price"
                value="price"
                onChange={this.updateChoice}
                className="dui-mr-4"
              />
              I don&#39;t think the experience is worth the price
            </label>
          </div>
          <div className="">
            <label htmlFor="external" className="radio-label">
              <input
                type="radio"
                name="reason"
                id="external"
                value="external"
                onChange={this.updateChoice}
                className="dui-mr-4"
              />
              I&#39;m going on a different trip
            </label>
          </div>
          <div className="">
            <label htmlFor="other" className="radio-label">
              <input
                type="radio"
                name="reason"
                id="other"
                value="other"
                onChange={this.updateChoice}
                className="dui-mr-4"
              />
              Other
            </label>
          </div>
        </div>
      </Dialog>
    );
  }
}

CancelModal.propTypes = {
  planCode: PropTypes.string,
  returnTo: PropTypes.string,
  onCloseModal: PropTypes.func,
  modalIsOpen: PropTypes.bool,
  cancelPlan: PropTypes.func
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      cancelPlan
    },
    dispatch
  );

export default connect(
  null,
  mapDispatchToProps
)(CancelModal);
